export default __webpack_public_path__ + "static/media/FeelGood.933a480f.svg";